import merge from './merge'

export default function(hideList) {
  let list = [
    merge({ name: 'Switch', label: '开关', setting: {
      disabled: false,
      width: 40,
      activeIconClass: '',
      inactiveIconClass: '',
      activeText: '打开',
      inactiveText: '关闭',
      activeValue: true,
      inactiveValue: false,
      activeColor: '#409EFF',
      inactiveColor: '#C0CCDA'
    }}),
    merge({ name: 'Rate', label: '评分', value: 0, setting: {
      max: 5,
      allowHalf: false,
      colors: ['#F7BA2A', '#F7BA2A', '#F7BA2A'],
      voidColor: '#C6D1DE',
      iconClasses: ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'],
      voidIconClass: 'el-icon-star-off',
      showText: false,
      textColor: '#1F2D3D',
      texts: ['极差', '失望', '一般', '满意', '惊喜'],
      showScore: false,
      scoreTemplate: '{value}'
    }}),
    merge({ name: 'InputNumber', label: '计数器', value: 0, setting: {
      max: Infinity,
      min: -Infinity,
      step: 1,
      stepStrictly: false,
      size: '',
      disabled: false,
      controlsPosition: ''
    }})
  ]
  if (typeof hideList === 'string') {
    list = list.filter(item => item.name !== hideList)
  } else if (Object.prototype.toString.call(hideList) === '[object Array]' && hideList.length) {
    list = list.filter(item => !hideList.find(i => i === item.name))
  }
  return list
}
